import appsco from '../Imgs/Sponsors/appsco.png'
import innpulsa from '../Imgs/Sponsors/innpulsa.png'
import pantera from '../Imgs/Sponsors/pantera.png'
import mintic from '../Imgs/Sponsors/mintic.png'
function Sponsors() {
  return (
    <div className="flex justify-center md:w-[100%] bg-gray">
      <div className="py-6 md:py-12">
        <div className="container mx-auto">
          <div className="flex flex-col md:grid md:grid-cols-3 lg:grid-cols-4 gap-2 md:gap-4">
            <div className="bg-white p-2 md:p-4">
              <img
                src={mintic}
                alt="Patrocinador 1"
                className="w-full h-auto min-h-[60px] max-h-[150px] min-w-[100px] md:min-h-[100px] md:max-h-[150px] md:min-w-[150px]"
              />
            </div>
            <div className="bg-white p-2 md:p-4">
              <img
                src={appsco}
                alt="Patrocinador 1"
                className="w-full h-auto min-h-[60px] max-h-[150px] min-w-[100px] md:min-h-[100px] md:max-h-[150px] md:min-w-[150px]"
              />
            </div>
            <div className="bg-white p-2 md:p-4">
              <img
                src={innpulsa}
                alt="Patrocinador 1"
                className="w-full h-auto min-h-[60px] max-h-[150px] min-w-[100px] md:min-h-[100px] md:max-h-[150px] md:min-w-[150px]"
              />
            </div>
            <div className="bg-white p-2 md:p-4">
              <img
                src={pantera}
                alt="Patrocinador 1"
                className="w-full h-auto min-h-[60px] max-h-[150px] min-w-[100px] md:min-h-[100px] md:max-h-[150px] md:min-w-[150px]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Sponsors
